import { startOfDay } from 'date-fns';
import { limitKeyFunctionMap } from 'shared/hooks/use-premium-feature-allowed';
import {
  getGoals,
  getLifeAreasDocs,
  getRelationshipDocs,
  getTagsDocs,
  getTaskDocs,
  getUser,
} from 'shared/services/backend-api';
import { TaskCreationData } from 'shared/types/electron';
import { InsightsTimeframes } from 'shared/types/insights';
import { LimitKeys } from 'shared/types/limit-keys';
import { TaskType } from 'shared/types/task-base';
import { getDateFormat } from 'shared/utils/get-date-format';
import { getTimeFormat } from 'shared/utils/get-time-format';
import { getWeekStartsOn } from 'shared/utils/get-week-starts-on';

import { IpcChannels } from './types';

export const subscribeToTaskCreationData = () => {
  // @ts-ignore
  const ipcRenderer = window.ipcRenderer;

  if (!ipcRenderer) {
    return;
  }

  ipcRenderer.on(IpcChannels.GetTaskCreationDataRequest, async () => {
    const user = await getUser();
    const habitTasks = await getTaskDocs({ type: TaskType.Habit });
    const habits =
      habitTasks?.filter(({ schedules }) => !!schedules?.length) ?? [];
    const goals = await getGoals();
    const activeGoals = goals.filter(
      ({ completedAt, archivedAt }) => !archivedAt && !completedAt,
    );
    const lifeAreas = await getLifeAreasDocs();
    const activeLifeAreas = lifeAreas.filter(({ archivedAt }) => !archivedAt);
    const tags = await getTagsDocs();
    const relationships = await getRelationshipDocs();
    const today = startOfDay(new Date());

    const data: TaskCreationData = {
      goals: activeGoals,
      lifeAreas: activeLifeAreas,
      tags,
      relationships,

      timeframe:
        user?.settings?.habitStatisticsTimeframe ?? InsightsTimeframes.Week,
      weekStartsOn: getWeekStartsOn(user),
      timeFormat: getTimeFormat(user),
      dateFormat: getDateFormat(user),
      createHabitAllowed: user
        ? limitKeyFunctionMap[LimitKeys.CreateHabit]({
            user,
            today,
            total: habits.length,
          })
        : false,
      createHabitTargetAllowed: user
        ? limitKeyFunctionMap[LimitKeys.HabitScheduleTarget]({
            user,
            today,
          })
        : false,
      createHabitIconAllowed: user
        ? limitKeyFunctionMap[LimitKeys.HabitIcons]({ user, today })
        : false,
      createGoalAllowed: user
        ? limitKeyFunctionMap[LimitKeys.CreateGoal]({
            user,
            today,
            totalUncompleted: activeGoals.length,
          })
        : false,
    };

    ipcRenderer.send(IpcChannels.GetTaskCreationDataResponse, data);
  });
};
